import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";
import {TableSort} from "../interfaces/table/table-sort";

@Injectable({
  providedIn: 'root'
})
export class PendingUsersService {
  private readonly apiService = inject(BaseApiService);

  async getPendingUsers(limit: number, offset: number, search: string, sort: TableSort | null) {
    return await this.apiService.post('/admin/pending-users', {
      offset: offset,
      limit: limit,
      search: search,
      sort: sort != null ? JSON.stringify(sort) : null
    });
  }

  async approvePendingUsers(id: string, role_id: string, location_id: string[]) {
    const body = {
      role_id: role_id,
      locations_ids: JSON.stringify(location_id.map(id => ({location_id: id})))
    }
    return await this.apiService.post(`/admin/approve-pending-user/${id}`, body);
  }

  async getRoles() {
    return await this.apiService.post(`/admin/roles`, {});
  }

  async rejectPendingUsers(id: string) {
    return await this.apiService.post(`/admin/reject-pending-user/${id}`, {});
  }
}
